/* ═══════════════════════════════════════════════════════
   C3 BEEF — Shopify Theme JS
═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── HAMBURGER MENU ───────────────── */
  const hamburger = document.getElementById('hamburger');
  const navLinks = document.querySelector('.nav-links');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('open');
      navLinks.classList.toggle('open');
    });
    navLinks.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        hamburger.classList.remove('open');
        navLinks.classList.remove('open');
      });
    });
  }

  /* ── NAV ELEVATION ON SCROLL ──────── */
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('elevated', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── SCROLL REVEAL ────────────────── */
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('on');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -28px 0px' });

  document.querySelectorAll('.sr').forEach(el => {
    const parent = el.closest(
      '.stats, .product-grid, .cat-grid, .testi-grid, .cert-grid, ' +
      '.gen-table, .values-grid, .related-grid, .cert-cards'
    );
    if (parent) {
      const siblings = [...parent.querySelectorAll('.sr')];
      el.style.transitionDelay = `${siblings.indexOf(el) * 0.1}s`;
    }
    obs.observe(el);
  });

  /* ── PRODUCT FILTER BAR ───────────── */
  const filterBtns = document.querySelectorAll('.filter-btn');
  if (filterBtns.length) {
    function applyFilter(cat) {
      document.querySelectorAll('.product-card').forEach(card => {
        if (cat === 'all' || card.dataset.category === cat) {
          card.classList.remove('hidden');
        } else {
          card.classList.add('hidden');
        }
      });
      const noResults = document.querySelector('.no-results');
      if (noResults) {
        const visible = document.querySelectorAll('.product-card:not(.hidden)').length;
        noResults.classList.toggle('show', visible === 0);
      }
    }

    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        applyFilter(btn.dataset.filter);
      });
    });
  }

  /* ── PRODUCT CARD CLICK DELEGATION ── */
  document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('click', e => {
      if (!e.target.closest('a') && !e.target.closest('button')) {
        const link = card.dataset.url;
        if (link) window.location.href = link;
      }
    });
  });

  /* ── PRODUCT IMAGE GALLERY ────────── */
  const thumbs = document.querySelectorAll('.ph-thumb');
  const mainImg = document.querySelector('.ph-main-img img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.src;
        if (src) mainImg.src = src;
      });
    });
  }

  /* ── PRODUCT TABS ─────────────────── */
  const tabBtns = document.querySelectorAll('.tab-btn');
  if (tabBtns.length) {
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        tabBtns.forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
        btn.classList.add('active');
        const content = document.getElementById('tab-' + target);
        if (content) content.classList.add('active');
      });
    });
  }

  /* ── PRODUCT OPTION SELECTORS ─────── */
  const optBtns = document.querySelectorAll('.ph-opt-btn');
  const variantSelect = document.getElementById('ProductSelect');
  if (optBtns.length && variantSelect) {
    const selectedValues = {};

    optBtns.forEach(btn => {
      const optIdx = parseInt(btn.dataset.optionIndex, 10);
      if (selectedValues[optIdx] === undefined) {
        const first = document.querySelector(`.ph-opt-btn[data-option-index="${optIdx}"][aria-pressed="true"]`);
        if (first) selectedValues[optIdx] = first.dataset.value;
      }
      btn.addEventListener('click', () => {
        document.querySelectorAll(`.ph-opt-btn[data-option-index="${optIdx}"]`).forEach(b => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        selectedValues[optIdx] = btn.dataset.value;

        const options = [...variantSelect.options];
        for (const option of options) {
          const variantTitle = option.text;
          const vals = variantTitle.split(' / ');
          if (Object.values(selectedValues).every((v, i) => vals[i] === v)) {
            variantSelect.value = option.value;
            break;
          }
        }
      });
    });
  }

  /* ── QUANTITY STEPPER ─────────────── */
  /* Single-input stepper (product page), if present. */
  const qtyMinus = document.getElementById('QtyMinus');
  const qtyPlus  = document.getElementById('QtyPlus');
  const qtyInput = document.getElementById('Quantity');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  /* Cart line steppers — one pair per row, so bind by attribute, not id.
     Quantities still apply on "Update Cart", matching the existing buttons. */
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap  = btn.closest('.qty-wrap');
      const input = wrap && wrap.querySelector('input[name="updates[]"]');
      if (!input) return;
      const step = btn.hasAttribute('data-qty-plus') ? 1 : -1;
      const next = (parseInt(input.value, 10) || 0) + step;
      input.value = next < 0 ? 0 : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

});
